
































import { Component, Vue } from 'vue-property-decorator'
import { createOrder } from '@/api/orders'
import { AppModule } from '@/store/modules/app'
import { TagsViewModule, ITagView } from '@/store/modules/tags-view'
import { OrdersModule, defaultOrderData } from '@/store/modules/orders'
import Sticky from '@/components/Sticky/index.vue'
import { Form } from 'element-ui'
import OrderInformation from './OrderInformation.vue'
import OrderContact from './OrderContact.vue'
import OrderProperty from './OrderProperty.vue'

@Component({
  name: 'OrderCreate',
  components: {
    OrderInformation,
    OrderContact,
    OrderProperty,
    Sticky
  }
})
export default class extends Vue {
  // @Prop({ default: false }) private isEdit!: boolean;
  private isEdit = false
  private orderForm = Object.assign({}, defaultOrderData);
  private loading = false;
  private orderRules = {
    subjectAddress: [{ required: true }],
    orderType: [
      {
        required: true,
        message: 'Please select a Product / Order Type',
        trigger: 'blur'
      }
    ],
    clientId: [{ required: true, message: 'Please select a Client', trigger: 'blur' }]
  };

  private tempTagView?: ITagView;

  get lang() {
    return AppModule.language
  }

  created() {
    this.fetchData()
    this.isEdit = false
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route)
  }

  private async fetchData() {
    const id = parseInt(this.$route.params && this.$route.params.id)
    // grab the data from this Order Id
    if (id) {
      // just use the item we have in module/cache
      // this.orderForm = await OrdersModule.copyOrder(id)

      // copy the relevant data from the order.
      // client and loan info
      this.orderForm.clientId = OrdersModule.orderSelected?.clientId || 0
      this.orderForm.clientOrderId = OrdersModule.orderSelected?.clientOrderId || ''
      this.orderForm.lenderName = OrdersModule.orderSelected?.lenderName || ''
      this.orderForm.loanNumber = OrdersModule.orderSelected?.loanNumber || ''
      // this.orderForm.orderType = OrdersModule.orderSelected?.orderType || ''
      // contact
      this.orderForm.contactFirstName =
        OrdersModule.orderSelected?.contactFirstName || ''
      this.orderForm.contactLastName = OrdersModule.orderSelected?.contactLastName || ''
      this.orderForm.contactPhone = OrdersModule.orderSelected?.contactPhone || ''
      this.orderForm.contactPhone2 = OrdersModule.orderSelected?.contactPhone2 || ''
      this.orderForm.contactEmail = OrdersModule.orderSelected?.contactEmail || ''
      this.orderForm.subjectAddress = OrdersModule.orderSelected?.subjectAddress || ''
      this.orderForm.subjectAddress2 = OrdersModule.orderSelected?.subjectAddress2 || ''
      this.orderForm.subjectCity = OrdersModule.orderSelected?.subjectCity || ''
      this.orderForm.subjectState = OrdersModule.orderSelected?.subjectState || ''
      this.orderForm.subjectPostalCode =
        OrdersModule.orderSelected?.subjectPostalCode || ''
      this.orderForm.subjectCountry = OrdersModule.orderSelected?.subjectCountry || 'US'
      this.orderForm.subjectCounty = OrdersModule.orderSelected?.subjectCounty || ''
      // Borrower
      this.orderForm.borrowerName = OrdersModule.orderSelected?.borrowerName || ''
      this.orderForm.borrowerName2 = OrdersModule.orderSelected?.borrowerName2 || ''

      console.debug(
        `Created new Order Copied from ${id} Borrower = ${this.orderForm.borrowerName}`
      )
    }

    const title = 'Create Order'
    // Set tagsview title
    this.setTagsViewTitle(title)
    // Set page title
    this.setPageTitle(title)
    if (id) {
      this.$notify({
        title: 'Success',
        message: `Your New Order was copied from # ${id}.`,
        type: 'success',
        duration: 2000
      })
    }
  }

  private setTagsViewTitle(title: string) {
    const tagView = this.tempTagView
    if (tagView) {
      tagView.title = `${title}-${this.orderForm.orderId}`
      TagsViewModule.updateVisitedView(tagView)
    }
  }

  private closeTagView() {
    const tagView = this.tempTagView
    if (tagView) {
      TagsViewModule.delView(tagView)
      this.toLastView(TagsViewModule.visitedViews, tagView)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath).catch((err) => {
        console.warn(err)
      })
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath }).catch((err) => {
          console.warn(err)
        })
      } else {
        this.$router.push('/').catch((err) => {
          console.warn(err)
        })
      }
    }
  }

  private setPageTitle(title: string) {
    document.title = `${title} - ${this.orderForm.orderId}`
  }

  private submitForm() {
    (this.$refs.orderForm as Form).validate(async(valid) => {
      if (valid) {
        this.loading = true

        // Clean phone number for API consumption
        if (this.orderForm.contactPhone) {
          this.orderForm.contactPhone = this.orderForm.contactPhone.replace(/\D/g, '')
        }
        if (this.orderForm.contactPhone2) {
          this.orderForm.contactPhone2 = this.orderForm.contactPhone2.replace(/\D/g, '')
        }

        const newOrder = await createOrder(this.orderForm)

        if (newOrder) {
          this.loading = false
          this.$notify({
            title: 'Success',
            message: `New Order # is ${newOrder.orderId}.`,
            type: 'success',
            duration: 2000
          })
          this.closeTagView()
          return true
        } else {
          console.log('Server-side error!')
        }
      } else {
        console.error('Client validation Error!')
      }
      this.loading = false
      return false
    })
  }

  private cancelForm() {
    this.closeTagView()
    return true
  }
}
